var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHistory = function SvgHistory(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "history")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Home",
    transform: "translate(-35.000000, -708.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history",
    transform: "translate(32.000000, 705.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "svg-hover",
    id: "Group-5-Copy",
    transform: "translate(4.000000, 4.000000)",
    stroke: "var(--primaryTextColor)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8.98521713 C15.9996608,13.4034845 12.4177586,16.9850475 7.99932155,16.9847083 C3.58105415,16.9843691 -0.00033922741,13.4022972 0,8.98402983",
    id: "Path",
    strokeDasharray: "1.5,3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4.18470829,
    x2: 8,
    y2: 8.98470829,
    id: "Line-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.4,
    y1: 9.38470829,
    x2: 10.6627417,
    y2: 10.4474499,
    id: "Line-6-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6703944,2.94142651 C12.2216222,1.48573736 10.2160344,0.584708288 8,0.584708288 C3.581722,0.584708288 0,4.16643029 0,8.58470829",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    transform: "translate(13.196891, 2.583154) rotate(132.000000) translate(-13.196891, -2.583154) ",
    points: "10.8 3.78159943 13.1968911 1.38470829 15.5937823 3.78159943"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history.bd137d25.svg";
export { ForwardRef as ReactComponent };